/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Map View Icon component.
 */
export const MapViewIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M15.945 5.856a.5.5 0 01-.334-.017L9.055 3.122a.5.5 0 00-.333-.018L2.358 4.986a.5.5 0 00-.358.48v15.05a.5.5 0 00.642.48l6.08-1.798a.5.5 0 01.333.018l6.54 2.717a.5.5 0 00.334.018l6.363-1.882a.5.5 0 00.359-.48V4.54a.5.5 0 00-.642-.48l-6.064 1.797zM8.949 3v16.09M15.73 5.71V21.8'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
    </svg>
  );
};
